import {
  Button,
  Center,
  Flex,
  Image,
  Modal,
  NumberInput,
  Text
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { getControllerIdList, getDevice, getWeather } from "pages/Admin/Device/apis/adminDeviceApis";
import RTSPPlayer from "pages/Home/ComponentF";
import ComponentG from "pages/Home/ComponentG";
import ComponentK from "pages/Home/ComponentK";
import { useState } from "react";
import { useQuery } from "react-query";
import styled from "styled-components";
import { getPathname } from "utils/getPathname";
import { updateChannelControlValue } from "../apis/adminSiteEditApis";

function ObjectItem(props) {
  const {
    id,
    object,
    imgyeList,
    objectList,
    setObjectList,
    objectOnClick,
    commList,
    setCommList,
  } = props;

  const pathName = getPathname();
  const imgye = imgyeList?.find((imgye) => imgye.obj_id === object.obj_id);

  const bsdId = object.bsd_id;
  const bsdControlId = object.bsd_ctrl_id;
  const objectId = object.object_id;
  const grpId = object.group_id;

  const [weather, setWeather] = useState([]);
  const [comm, setComm] = useState([]);

  // 클릭한 마우스 위치
  const [modalPosition, setModalPosition] = useState({
    x: 0,
    y: 0,
  });

  useQuery(["weatherData", grpId], () => getWeather(grpId), {
    keepPreviousData: true,
    refetchInterval: 60 * 1000,   // 1분에 1번 호출
    refetchOnWindowFocus: false,  // 화면 포커스 시 재호출 중지
    refetchIntervalInBackground: true,
    onSuccess: weatherData => {
      setWeather(weatherData);
    },
  });

  useQuery(["commData", grpId], () => getControllerIdList(grpId), {
    // refetchInterval:  10 * 1000,
    // staleTime : 10 * 1000,
    refetchInterval: 60 * 1000,   // 1분에 1번 호출
    refetchOnWindowFocus: false,  // 화면 포커스 시 재호출 중지
    refetchIntervalInBackground: true,
    onSuccess: (commData) => {
      if (typeof setCommList === "function") {
        setCommList(commData);
      } else {
        setComm(commData);
      }
    },
  });

  const [objectControlModalOpened, objectControlModal] = useDisclosure(false);
  const [deviceControlList, setDeviceControlList] = useState([]);
  const [objectControlValue, setObjectControlValue] = useState(0);

  const handleObjectControlModalOpen = () => {
    if (!object?.bsd_ctrl_id || object?.sw_cs !== "Y") return;

    // setPauseApiCall(true);

    getDevice(bsdId).then((res) => {
      setDeviceControlList(res.ctrl);

      const control = res.ctrl?.find(
        (item) => item.bsd_ctrl_id === object.bsd_ctrl_id
      );

      if (control?.chnnl_ctrl_value != null) {
        setObjectControlValue(
          Number(control.chnnl_ctrl_value)
        );
      }

      objectControlModal.open();
    });
  };

  const handleObjectControlModalClose = () => {
    // setPauseApiCall(false);
    objectControlModal.close();
  };

  const updateObjectControlValue = async (objectControlValue) => {
    const updatedObject = {
      ...object,
      chnnl_ctrl_value: String(objectControlValue),
    };

    const updatedDeviceControlList = deviceControlList.map((item) => {
      return item.bsd_ctrl_id === object.bsd_ctrl_id ? {...item, chnnl_ctrl_value: String(objectControlValue)} : item;
    });
    setDeviceControlList(updatedDeviceControlList);

    const updatedObjectList = objectList.map((item) => {
      return item.obj_id === object.obj_id ? updatedObject : item;
    });
    setObjectList(updatedObjectList);

    // 백엔드 전달용 데이터
    const changedItem = {
      bsd_id: updatedObject.bsd_id,
      bsd_ctrl_id: updatedObject.bsd_ctrl_id,
      chnnl_ctrl_value: updatedObject.chnnl_ctrl_value,
    };

    try {
      const response = await updateChannelControlValue(changedItem);
      alert(response);
    } catch (error) {
      console.error(error);
      alert("업데이트 중 오류가 발생했습니다.");
    }

    handleObjectControlModalClose();
    // setCountdown(60);
  };

  const ClickFunction = (e) => {
    if (objectOnClick) {
      objectOnClick(id);
      return;
    }

    setModalPosition({
      x: e.clientX,
      y: e.clientY,
    });

    handleObjectControlModalOpen(objectId);
  };

  const isValueInImgye =
    object.chnnl_sttus_value &&
    Number(imgye?.imgye_st) <= Number(object.chnnl_sttus_value) &&
    Number(object.chnnl_sttus_value) <= Number(imgye?.imgye_ed);

  const getNumberValue = (val) => {
    return (Number(val) > 32768
                        ? (Number(val) - 65536).toString()
                        : (val ?? '--')
    );
  }

  const ObjectComponent = () => {
    if (object.view_yn === "Y") {
      if (object.type === "1") {
        if (isValueInImgye) {
          if (imgye?.img_url) {
            return (
              <>
                <Flex direction="column" align={"center"}>
                  <div>
                    <Image
                      src={`/static/files/${imgye.img_url}`}
                      alt="With default placeholder"
                      withPlaceholder
                      width={"100%"}
                      height={"100%"}
                    />
                  </div>
                  <Text
                    fz="sm"
                    fw={500}
                    style={{ opacity: pathName === "site_edit" ? 1 : 0 }}
                  >
                    {object.obj_nm}
                  </Text>
                </Flex>
              </>
            );
          } else {
            return (
              <>
                <S.ContentsDiv
                  $object={imgye}
                  style={{ textAlign: object.t_sort }}
                >
                  {object.t_yn === "Y" && <Text fw={500}>{imgye.t_cont}</Text>}
                  {object.t_yn === "N" && (
                    <Text fw={500}>
                      { getNumberValue(object?.chnnl_sttus_value) }
                    </Text>
                  )}
                  <Text
                    fz="sm"
                    fw={500}
                    style={{
                      height: pathName !== "site_edit" && 0,
                      opacity: pathName === "site_edit" ? 1 : 0,
                    }}
                  >
                    {object.obj_nm}
                  </Text>
                </S.ContentsDiv>
              </>
            );
          }
        }
        if (!isValueInImgye) {
          if (object.img_url) {
            return (
              <>
                <Flex direction="column" align={"center"}>
                  <div>
                    <Image
                      src={`/static/files/${object.img_url}`}
                      alt="With default placeholder"
                      withPlaceholder
                      width={"100%"}
                      height={"100%"}
                    />
                  </div>
                  <Text
                    fz="sm"
                    fw={500}
                    style={{
                      height: pathName !== "site_edit" && 0,
                      opacity: pathName === "site_edit" ? 1 : 0,
                    }}
                  >
                    {object.obj_nm}
                  </Text>
                </Flex>
              </>
            );
          } else if (object.bsd_id) {
            return (
              <>
                <S.ContentsDiv $object={object} style={{ width: "100%" }}>
                  {object.t_yn === "Y" ? (
                    <Text fw={500}> {object.t_cont}</Text>
                  ) : (
                    <>
                      {object?.sw_cs === "N" && (
                        <Text fw={500}>
                          { getNumberValue(object?.chnnl_sttus_value) }
                        </Text>
                      )}
                      {object?.sw_cs === "Y" && (
                        <Text fw={500}>
                            { getNumberValue(object?.chnnl_ctrl_value) }
                        </Text>
                      )}
                    </>
                  )}
                  <Text
                    fz="sm"
                    fw={500}
                    style={{
                      height: pathName !== "site_edit" && 0,
                      opacity: pathName === "site_edit" ? 1 : 0,
                    }}
                  >
                    {object.obj_nm}
                  </Text>
                </S.ContentsDiv>
              </>
            );
          } else {
            return (
              <>
                <S.ContentsDiv $object={object}>
                  <Flex direction="row" gap={10}>
                    {object.t_yn === "Y" && (
                      <Text fw={500}> {object.t_cont}</Text>
                    )}
                  </Flex>
                  <Text
                    fz="sm"
                    fw={500}
                    style={{
                      height: pathName !== "site_edit" && 0,
                      opacity: pathName === "site_edit" ? 1 : 0,
                    }}
                  >
                    {object.obj_nm}
                  </Text>
                </S.ContentsDiv>
              </>
            );
          }
        }
      } else if (object.type === "2") {
        return <RTSPPlayer object={object} />;
      } else if (object.type === "3") {
        return <ComponentG bsdId={bsdId} weather={weather} />;
      } else if (object.type === "4") {
        return <ComponentK bsdId={bsdId} comm={commList || comm} />;
      }
    }
  };

  return (
    <>
      <div id={id} key={id} onClick={ClickFunction}>
        <ObjectComponent />
      </div>
      <Modal
        title={object.obj_nm}
        opened={objectControlModalOpened}
        onClose={handleObjectControlModalClose}
        size="lg"
        zIndex={2010}
        centered={false}
        styles={{
          inner: {
            position: "fixed",
            inset: 0,
            display: "block",
            padding: 0,
            pointerEvents: "none",
          },
          content: {
            position: "absolute",
            left: Math.max(
              0,
              Math.min(
                modalPosition.x - 200,
                window.innerWidth - 400
              )
            ),
            transform: "translate(-50%, -50%)",
            margin: 0,
            width: "400px",
            minWidth: "400px",
            maxWidth: "400px",
            boxSizing: "border-box",
            pointerEvents: "auto",
          },
        }}
      >
        <DeviceControlComponent
          objectControlState={deviceControlList?.find(
            (control) => control.bsd_ctrl_id === bsdControlId
          )}
          imgye={imgye}
          objectControlValue={objectControlValue}
          setObjectControlValue={setObjectControlValue}
          onCancel={handleObjectControlModalClose}
          onConfirm={() => updateObjectControlValue(objectControlValue)}
        />
      </Modal>
    </>
  );
}
export default ObjectItem;

function DeviceControlComponent({objectControlState, imgye, objectControlValue, setObjectControlValue, onCancel, onConfirm}) {
  if (!objectControlState || !imgye?.imgye_st || !imgye?.imgye_ed) {
    return null;
  }

  return (
    <>
      <Flex gap={5}>
        <Text fw={600}>채널명: </Text>
        <Text fw={300}>{objectControlState.chnnl_nm}</Text>
      </Flex>

      {objectControlState.unit && (
        <Flex gap={5}>
          <Text fw={600}> 단위: </Text>
          <Text fw={300}>{objectControlState.unit}</Text>
        </Flex>
      )}

      <Flex gap={5}>
        <Text fw={600}>범위: </Text>
        <Text fw={300}>{imgye.imgye_st}</Text>~
        <Text fw={300}>{imgye.imgye_ed}</Text>
      </Flex>

      <NumberInput
        min={Number(imgye.imgye_st)}
        max={Number(imgye.imgye_ed)}
        value={objectControlValue}
        description={
          objectControlState.chnnl_no === "10"
            ? "0:주 펌프, 1:보조펌프"
            : ""
        }
        onChange={setObjectControlValue}
      />

      <Center>
        <Flex mt={10} gap={10}>
          <Button
            variant="outline"
            color="red"
            onClick={onCancel}
          >
            취소
          </Button>

          <Button onClick={onConfirm}>
            확인
          </Button>
        </Flex>
      </Center>
    </>
  );
}

const S = {
  DefaultObject: styled.div`
    width: ${({ $object }) => $object.width}px;
    height: ${({ $object }) => $object.height}px;
  `,

  ContentsDiv: styled.div`
    color: ${({ $object }) => $object.t_font_c};
    font-size: ${({ $object }) => `${$object.t_font_s}px`};
    text-align: ${({ $object }) => $object.t_sort};
    background-color: ${({ $object }) => $object.t_cont_bg};
  `,
};
